import React from 'react'

export default function ErrorStatus({status}: any) {
  return <div>{status}</div>
}
